import React from 'react';

import SpinnerRing from 'components/SpinnerRing';
import Toast from 'components/Toast/Toast';

const ActionLoading = ({ responseStatus, isLoading }) => (
  <>
    {responseStatus?.resolved && (
      <Toast
        show
        type={responseStatus.isFailed ? 'error' : 'success'}
        message={responseStatus.msg}
        duration={responseStatus.isFailed ? 5000 : 3000}
      />
    )}
    {isLoading && <SpinnerRing />}
  </>
);

export default ActionLoading;
